/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_FeatureInputs */

const en_landing_pricing_compare_feature = /** @type {(inputs: Landing_Pricing_Compare_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const zh_landing_pricing_compare_feature = /** @type {(inputs: Landing_Pricing_Compare_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Landing_Pricing_Compare_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_feature = /** @type {((inputs?: Landing_Pricing_Compare_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_feature(inputs)
	return zh_landing_pricing_compare_feature(inputs)
});
export { landing_pricing_compare_feature as "landing.pricing.compare_feature" }